import React from "react";
import { NakiRadioFreeBadgeTemplate } from "themes/application/payment/components";

const NakiRadioFreeBadge = (props) => {
    return <NakiRadioFreeBadgeTemplate {...props} />;
};

export default NakiRadioFreeBadge;
